import { IPlayerParams } from 'src/interfaces/PlayerParams';
import { IUserPreferences } from 'src/interfaces/UserPreferences';
import { get, put } from 'src/utils/apiUtils';
import { debounce } from 'src/utils/debounceUtils';
import {
  DEFAULT_AUTOPLAY_ENABLED,
  DEFAULT_MARKER_PREVIEW_ENABLED,
  DEFAULT_PLAYBACK_RATE,
  DEFAULT_SUBTITLE_ENABLED,
  DEFAULT_SUBTITLE_LANGUAGE,
  DEFAULT_VOLUME_PERCENT,
  UPDATE_PREFERENCES_DEBOUNCE_TIME,
  USER_PREFERENCES_URL,
} from './constants';

class UserPreferencesService {
  private playerParams: IPlayerParams;

  constructor(playerParams: IPlayerParams) {
    this.playerParams = playerParams;
  }

  generateRequestUrl() {
    const { user, token } = this.playerParams;

    if (!user || !token) {
      throw new Error('User or token param is missing');
    }

    return `${USER_PREFERENCES_URL}/user-preferences/${user}?applicationCode=${token}`;
  }

  async fetchPreferences() {
    try {
      const result = await get(this.generateRequestUrl());
      return this.parsePreferences(result);
    } catch (error) {
      return this.parsePreferences({});
    }
  }

  private async _updatePreferences(preferences: Partial<IUserPreferences>) {
    try {
      await put(this.generateRequestUrl(), preferences);
    } catch (error) {
      console.error(error);
    }
  }

  updatePreferences = debounce(this._updatePreferences, UPDATE_PREFERENCES_DEBOUNCE_TIME);

  parsePreferences(preferences: Partial<IUserPreferences>): IUserPreferences {
    return {
      autoplayEnabled: preferences.autoplayEnabled ?? DEFAULT_AUTOPLAY_ENABLED,
      volumePercent: preferences.volumePercent ?? DEFAULT_VOLUME_PERCENT,
      markerPreviewEnabled: preferences.markerPreviewEnabled ?? DEFAULT_MARKER_PREVIEW_ENABLED,
      subtitleLanguage: preferences.subtitleLanguage ?? DEFAULT_SUBTITLE_LANGUAGE,
      playbackRate: preferences.playbackRate ?? DEFAULT_PLAYBACK_RATE,
      subtitleEnabled: preferences.subtitleEnabled ?? DEFAULT_SUBTITLE_ENABLED,
    };
  }
}

export default UserPreferencesService;
